import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import ImageCropper from './ImageCropper'

import { setImageForReplace, setIsButtonDisable } from 'store/entities/gallery/actions'
import { getImageForReplace, getIsButtonDisable } from 'store/entities/gallery/selectors'

const mapStateToProps = state => ({
  imageForReplace: getImageForReplace(state),
  isButtonDisable: getIsButtonDisable(state),
})

const mapDispatchToProps = dispatch => ({
  setStateToDefault: () => {
    dispatch(setImageForReplace(null))
    dispatch(setIsButtonDisable(true))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImageCropper))
